import { useCallback } from 'react'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { useDuplicateSalesDocument } from '@features/invoices/hooks/useDuplicateSalesDocument'

import { useQuote } from '../../../contexts/quoteContext'

export const useDuplicateQuote = () => {
  const { quoteId } = useQuote()
  const { duplicateSalesDocument } = useDuplicateSalesDocument()

  const duplicateQuote = useCallback(
    () => duplicateSalesDocument(quoteId, InvoiceDocumentType.Quote),
    [duplicateSalesDocument, quoteId],
  )

  return {
    duplicateQuote,
  }
}
